import React, { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { BaseProperty } from '../types';


interface NavigateToPropertyProps {
  properties: BaseProperty[];
  selectedPropertyId: number | null;
}

export const NavigateToProperty: React.FC<NavigateToPropertyProps> = ({ properties, selectedPropertyId }) => {
  const map = useMap();

  useEffect(() => {
    if (selectedPropertyId) {
      const selectedProperty = properties.find(p => p.property_id === selectedPropertyId);
      if (selectedProperty) {
        map.setView(
          [selectedProperty.latitude, selectedProperty.longitude],
          undefined,
          {
            animate: true,
            duration: 0.5
          }
        );
      }
    }
  }, [selectedPropertyId, properties, map]);

  return null;
}
